import { render } from "./DashobardMyProfilePage.vue?vue&type=template&id=3f1c2fc4"
import script from "./DashobardMyProfilePage.vue?vue&type=script&lang=js"
export * from "./DashobardMyProfilePage.vue?vue&type=script&lang=js"

import "./DashobardMyProfilePage.vue?vue&type=style&index=0&id=3f1c2fc4&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__